import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SearchAndSortWindow from "@/components/CvrConvert/VehiclesListParts/SearchAndSortWindow.vue"
import { Ref, ref, computed } from 'vue';

type selectableItemType = {
  id: string | number;
  key: string;
  label: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchAttribute',
  props: {
    width: { default: 100 },
    modelValue: {},
    items: {},
    windowKey: {}
  },
  emits: ['update:modelValue', 'changeSortType', 'closeWindow', 'search', 'setIsAllSelected'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const selectedItems: Ref<{[key: string]: boolean}> = ref(setSelectedItems(props.modelValue))

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function setSelectedItems(value: string[]) {
  const statuses: { [key: string]: boolean; } = {}
  if (!props.items || props.items.length === 0) {
    return statuses;
  }
  props.items.forEach((selectableStatus: selectableItemType) => {
    const status = value.includes(selectableStatus.key)
    statuses[selectableStatus.id] = status
  })
  return statuses
}

function plasticSurgeryStringArray(value: {[key: string]: boolean}) {
  const statuses: string[] = []
  props.items.forEach((selectableStatus: selectableItemType) => {
    if (value[selectableStatus.id]) {
      statuses.push(selectableStatus.key)
    }
  })
  return statuses
}

function setSelectAll(status: boolean) {
  props.items.forEach((selectableStatus: selectableItemType) => {
    selectedItems.value[selectableStatus.id] = status
  })
}

function closeWindow(status: boolean) {
  emits('closeWindow', status)
}

function search() {
  modelValue.value = plasticSurgeryStringArray(selectedItems.value)
  emits('search')
}

function setIsAllSelected($event: { windowKey: string; isAllSelected: boolean; }) {
  emits('setIsAllSelected', $event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SearchAndSortWindow, {
    items: props.items,
    modelValue: selectedItems.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event)),
    candidateLabel: "label",
    isSortable: false,
    width: props.width,
    windowKey: props.windowKey,
    onClose: closeWindow,
    onSetSelect: setSelectAll,
    onSearch: search,
    onSetIsAllSelected: setIsAllSelected
  }, null, 8, ["items", "modelValue", "width", "windowKey"]))
}
}

})